import { createApp } from 'vue'
import App from './App.vue'
import 'vant/lib/index.css';
import '@/assets/font/font.scss'
import { createPinia } from 'pinia'
import waterfall from "vue-waterfall2";
import router from './router'
import './style/main.scss'
import 'amfe-flexible'
import './utils/rem'
import i18n from './locales/index'
import Directives from '@/utils/directives';
import Brige from './utils/brige';
import { isProd } from './utils';
(window as any).APLINK_STARNEST_BRIGE = new Brige('FlutterStartNetMessageChannel');
const app = createApp(App)
if (!isProd) {
  var vConsole = new window.VConsole();
}

app.use(createPinia())
app.use(router)
app.use(i18n)
app.use(Directives)
app.use(waterfall)
app.mount('#app')